import { graphql } from '@/generated/gql';

export const NEGOTIATION_DETAIL_QUERY = graphql(/* GraphQL */ `
  query NegotiationDetail($id: UUID!) {
    tesseract {
      negotiationCase(id: $id) {
        id
        sequenceNumber
        status
        processStatus
        processSteps {
          variant
          status
        }
        isReleasable
        demand {
          id
          sequenceNumber
        }
        supplier {
          id
          internalId
          name
          contact {
            id
            internalId
            firstName
            lastName
            email
            language
          }
          location {
            id
            internalId
            city
            countryCode
            postalCode
            address
          }
        }
        # this is needed to invalidate the Apollo cache after resetting a
        # negotiation case in order to also reset the (negotiated) quote widgets
        quote {
          id
        }
        negotiatedQuote {
          id
        }
      }
    }
  }
`);
